import React from 'react'
import {Navigate, NavigateProps} from 'react-router-dom'
import {withLocalePath} from './localePaths'
import {useI18n} from './I18nContext'

export function NavigateLocalized(
  props: Omit<NavigateProps, 'to'> & {to: string},
) {
  const {locale} = useI18n()
  const to = withLocalePath(locale, props.to)
  return <Navigate {...props} to={to} />
}
